module.exports = __webpack_public_path__ + "img/cooperate-hero.9be1a506.png";